import {
  EnvironmentName,
  EnvironmentSpecificEnv,
} from './environment-specific.type';

export const environmentSpecificEnv: EnvironmentSpecificEnv = {
  environmentName: EnvironmentName.QA,
  production: false,
  googleAnalytics: {
    id: 'UA-31203397-3',
    tag: 'GTM-K8TC847',
  },
  recaptchaKey: '6Le-VWUqAAAAAPKHxVndckZ4NKNjSmf_YEN-VbNG',
  oktaClientId: '0oa1c3f10yqPqRv6h0h8',
  oktaIssuer:
    'https://alliancewebs.oktapreview.com/oauth2/auslliad098ikdxec0h7',
  splitKey: '8c77t7v3e3uo99228kvepchfjs4hd09ddvuc',
  showOktaSignInButton: true,
  apiSubDomain: 'qa-api',
};
